import Vue from "vue";

const state = {
  report: {},
  total: 0
};

const getters = {};

const actions = {
  LOAD_DASHBOARD_DATA: async function({ commit }, payload) {
    await Vue.prototype.$axios
      .get(
        "reports/sales/",
        {
          params: payload
        }
      )
      .then(res => {
        commit("SET_REPORT", res.data.report);
      });
  }
};

const mutations = {
  SET_REPORT: function (state, payload) {
    state.report = payload
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
